// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dRlFw","newExpiryDate":"styles_newExpiryDate__2QwuE","footer":"styles_footer__2tX5U"};